module.exports = __webpack_public_path__ + "static/media/galerija_2023 (11).138e5646.png";